import 'regenerator-runtime/runtime';
import { takeEvery } from 'redux-saga/effects';
import {
  AngebotsId,
  GlobalAction,
  GlobalActions,
  GlobalEventDispatcher,
  NavigationRoute,
} from '@ps20-frontend/shop-integration-redux';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App, isTiergruppeActive } from '@ps20-frontend/frontend-models';
import { childAppsConfig } from '../../childAppsConfig';
import { IAppState } from '../localStore';
import { checkActionType } from './helpers/checkActionType';

interface OwnedWarenkorbRow extends AngebotsId {
  ownerAppId?: App;
}

function isOwnedByTiergruppe(
  globalEventDispatcher: GlobalEventDispatcher,
  target: NavigationRoute,
): boolean {
  const shopState: IAppState = globalEventDispatcher.findStoreRef(App.SHOP)?.store.getState();
  if (!isTiergruppeActive(shopState?.transientState?.featureToggles)) {
    return false;
  }
  const dashboardState: { warenkorb?: OwnedWarenkorbRow[] } =
    globalEventDispatcher.findStoreRef(App.SHOP_DASHBOARD)?.store.getState();
  return (dashboardState?.warenkorb ?? []).some(
    row =>
      row.ownerAppId === App.TGV &&
      row.appId === target.appId &&
      (row.angebotsId ?? undefined) === (target.angebotsId ?? undefined),
  );
}

// NOSONAR

export function* watchNavigationRequested(): Generator<ForkEffect> {
  yield takeEvery(GlobalActions.NAVIGATION_REQUESTED, safeSaga(navigationRequested, App.SHOP));
}

export function navigationRequested(action: GlobalAction<NavigationRoute>): void {
  checkActionType(action.type, GlobalActions.NAVIGATION_REQUESTED);
  const globalEventDispatcher = GlobalEventDispatcher.getInstance();
  const actionPayload: NavigationRoute = action.payload;

  if (isOwnedByTiergruppe(globalEventDispatcher, actionPayload)) {
    globalEventDispatcher.dispatch(
      new GlobalActions().tiergruppeAngebotEditRequested({
        appId: actionPayload.appId,
        angebotsId: actionPayload.angebotsId,
      }),
    );
    return;
  }

  try {
    const route = childAppsConfig.mapAppNameToAssignedRoute(actionPayload.appId);
    let newHash;

    if (route) {
      const subroute = actionPayload.subroute;
      if (subroute) {
        newHash = `#${route}${subroute}`;
      } else {
        newHash = `#${route}`;
      }

      if (actionPayload.angebotsId) {
        newHash += '?angebotsId=' + actionPayload.angebotsId;
      }

      window.location.hash = newHash;
    } else {
      throw new Error(`route for app ${actionPayload.appId} is undefined`);
    }
    globalEventDispatcher.dispatch(new GlobalActions().navigationCompleted(actionPayload));
  } catch (error) {
    globalEventDispatcher.dispatch({
      type: GlobalActions.NAVIGATION_COMPLETED,
      error: true,
      payload: error,
    });
  }
  focusToolbar();
}

export const focusToolbar = (): void => {
  const nativeElement: HTMLElement = document.querySelector('custom-toolbar');
  if (nativeElement != null) {
    nativeElement.tabIndex = -1;
    nativeElement.focus();
    nativeElement.style.outlineWidth = '0';
  }
};
